import { Checkbox } from "components/DesignSystem/Checkbox/Checkbox";
import { Combobox } from "components/DesignSystem/Combobox/Combobox";
import { useTypedFormikContext } from "hooks/useTypedFormikContext";
import { ChangeEvent } from "react";
import { LLC_TAX_OPTIONS } from "v2/components/onboarding/steps/EntityTypeStep/entityOptions";
import { ENTITY_TYPE_IDS, TAXED_AS } from "v2/constants/entityTypes";
import { EntityFormValues } from "./modes/ManualMode";

const TAX_OPTIONS = LLC_TAX_OPTIONS.map(({ key, name }) => ({
  value: key,
  label: name,
}));

const S_CORP_TOOLTIP =
  "A corporation that has elected pass-through taxation, where profits and losses flow to shareholders' personal tax returns rather than at the corporate level.";

export const TaxClassificationField = () => {
  const { values, setFieldValue } = useTypedFormikContext<EntityFormValues>();

  const isCorporation = values.formationType === ENTITY_TYPE_IDS.ccorp;
  const isLlc = values.formationType === ENTITY_TYPE_IDS.llc;
  const taxValue =
    TAX_OPTIONS.find(({ value }) => value === values.taxedAs) ?? null;

  const handleSCorpChange = (event: ChangeEvent<HTMLInputElement>) =>
    setFieldValue("taxedAs", event.target.checked ? TAXED_AS.S_CORP : "");

  if (isCorporation) {
    return (
      <Checkbox
        name="taxedAs"
        label="My corporation is taxed as an S-Corp"
        tooltipText={S_CORP_TOOLTIP}
        checked={values.taxedAs === TAXED_AS.S_CORP}
        onChange={handleSCorpChange}
      />
    );
  }

  if (!isLlc) return null;

  return (
    <Combobox
      withForm
      required
      name="taxedAs"
      label="How is your LLC taxed?"
      placeholder="Select tax classification"
      size="regular"
      components={{ ClearIndicator: () => null }}
      menuPortalTarget={document.body}
      shouldValidateOnChange={false}
      value={taxValue}
      options={TAX_OPTIONS}
    />
  );
};
